<template>
  <form v-if="Territories != null" @submit.prevent="handleSave">
    <div class="tf-data-inputs">
      <div v-for="item in DataInputs">
        <DropDownMulti v-if="item.type === 'select-multi'" :item="item" :inputType="InputType" :options="getOptions(item)" @dropdown-func-multi="handleSearchResultClickMulti" @multi-remove="handleRemoveSelectedItem" @edit-type="handleEditInputType" />
        <DropDown v-if="item.type === 'select'" :item="item" :inputType="InputType" :options="getOptions(item)" @dropdown-func="handleSearchResultClick" @edit-type="handleEditInputType" />
        <DataInput v-if="item.type === 'text' || item.type === 'tel' || item.type === 'email'" :dataInput="item" :type="item.type" @inputValue="handleInputValue" />
      </div>
    </div>
    <div id="mds-invalidTestNotice" class="modal-test-submit-invalid-prompt" v-if="Incomplete.length != 0 && IsWarning">
      <div class="modal-test-invalid-prompt">
        <div class="tf-warning-cont-box">
          <div class="tf-warning-cont-text">The following values are missing:</div>
          <div class="tf-warning-cont-img-box" @click="handleCloseWarning">
            <img class="tf-warning-cont-img" :src="require('@/assets/svg/SVG/x.svg')">
          </div>
        </div>
        <div class="tf-warning-value-box">
          <div class="tf-warning-value-text" v-for="value in Incomplete" :key="value">{{ value }}</div>
        </div>
        <!-- <div id="mds-returnToTest" class="modal-test-submit-return-btn" @click="handleReturn" style="margin: 10px;">
          RETURN TO TEST
        </div> -->
      </div>
    </div>
    <div class="tf-form-btn-box">
      <div>
        <div v-if="Mode === 'edit'" class="tf-cancel-btn" @click="handleCancel">CANCEL</div>
      </div>
      <div>
        <button class="tf-submit-btn" type="submit">SAVE</button>
      </div>
    </div>
  </form>
</template>

<script>
import { useDealerStore } from '@/store/DealerStore';
import DropDown from './DropDown.vue';
import DataInput from './DataInput.vue';
import gsap from 'gsap';
import { useTerritoryStore } from '@/store/TerritoryStore';
import DropDownMulti from './DropDownMulti.vue';

export default {
  components: {
    DropDown,
    DataInput,
    DropDownMulti
  },
  props: [
    'dataInputs'
  ],
  computed: {
    Incomplete () {
      return useTerritoryStore().incomplete;
    },
    IsWarning () {
      return useTerritoryStore().isWarning;
    },
    InputType () {
      return useTerritoryStore().inputType;
    },
    DataInputs () {
      return this.$props.dataInputs ? this.$props.dataInputs : null;
    },
    Mode () {
      return useTerritoryStore().Mode;
    },
    States () {
      return useTerritoryStore().tmpStates;
    },
    Regions () {
      return useTerritoryStore().regions;
    },
    Territories () {
      return useTerritoryStore().territories;
    },
    SelectedTerritory () {
      return useTerritoryStore().SelectedTerritory;
    },
  },
  methods: {
    handleEditInputType (input) {
      useTerritoryStore().inputType = input;
    },
    handleCancel () {
      const territoryStore = useTerritoryStore();
      territoryStore.setMode('add');
      gsap.to('#territory-row-' + this.SelectedTerritory.territoryId, {
        backgroundColor: '#FFFFFF'
      });
      territoryStore.tmpStates = useDealerStore().states;
      territoryStore.setSelectedTerritory(null);
    },
    handleRemoveSelectedItem (item, prod) {
      if (prod.field === 'state') {
        prod.value = prod.value.filter((el) => el.name != item.name);
        useTerritoryStore().tmpStates.push(item);
        useTerritoryStore().tmpStates.sort((a, b) => a.name.localeCompare(b.name));
      }
    },
    handleSearchResultClickMulti (product, element) {
      this.selectedProducts = product;
      const territoryStore = useTerritoryStore();
      var selectedField;
      if (this.Mode === 'add') {
        selectedField = territoryStore.territoryAddInputs.find((item) => item.field === element.field);
      } else if (this.Mode === 'edit') {
        selectedField = territoryStore.territoryInputs.find((item) => item.field === element.field);
      }
      var isSelected = selectedField.value.find((item) => item.name === product.name);
      if (!isSelected) {
        selectedField.value.push(product);
      }
      isSelected = null;
      if (element.field === 'state') {
        useTerritoryStore().tmpStates = useTerritoryStore().tmpStates.filter((item) => item.name != product.name);
      }
    },
    handleSearchResultClick (product, element) {
      this.selectedProduct = product;
      const territoryStore = useTerritoryStore();
      var selectedField;
      if (this.Mode === 'add') {
        selectedField = territoryStore.territoryAddInputs.find((item) => item.field === element.field);
      } else if (this.Mode === 'edit') {
        selectedField = territoryStore.territoryInputs.find((item) => item.field === element.field);
      }
      selectedField.value = product;
    },
        getCountryCodeLength (digits) {
      const cc3 = new Set([
        210, 211, 212, 213, 216, 218, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229,
        230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245,
        246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 260, 261, 262,
        263, 264, 265, 266, 267, 268, 269, 291, 297, 298, 299, 350, 351, 352, 353, 354,
        355, 356, 357, 358, 359, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380,
        381, 382, 383, 385, 386, 387, 389, 420, 421, 423, 500, 501, 502, 503, 504, 505,
        506, 507, 508, 509, 590, 591, 592, 593, 594, 595, 596, 597, 598, 599, 670, 672,
        673, 674, 675, 676, 677, 678, 679, 680, 681, 682, 683, 685, 686, 687, 688, 689,
        690, 691, 692, 850, 852, 853, 855, 856, 880, 886, 960, 961, 962, 963, 964, 965,
        966, 967, 968, 970, 971, 972, 973, 974, 975, 976, 977, 992, 993, 994, 995, 996, 998
      ]);
      const cc2 = new Set([
        20, 27, 30, 31, 32, 33, 34, 36, 39, 40, 41, 43, 44, 45, 46, 47, 48, 49,
        51, 52, 53, 54, 55, 56, 57, 58, 60, 61, 62, 63, 64, 65, 66, 70, 76, 77,
        81, 82, 84, 86, 90, 91, 92, 93, 94, 95, 98
      ]);
      if (digits.length >= 3 && cc3.has(Number(digits.slice(0, 3)))) {return 3;}
      if (digits.length >= 2 && cc2.has(Number(digits.slice(0, 2)))) {return 2;}
      return 1;
    },
    handleInputValue (item) {
      if (item.field === 'managerPhone' || item.field === 'managerMobilePhone') {
        const raw = item.value;
        const hasCountryCode = raw.trimStart().startsWith('+');
        const digits = raw.replace(/\D/g, '');

        if (hasCountryCode) {
          const ccLen = this.getCountryCodeLength(digits);
          const cc = digits.slice(0, ccLen);
          const local = digits.slice(ccLen);
          let formatted = `+${cc}`;
          if (local.length > 0 && local.length <= 3) {
            formatted += ` (${local}`;
          } else if (local.length > 3 && local.length <= 6) {
            formatted += ` (${local.slice(0, 3)}) ${local.slice(3)}`;
          } else if (local.length > 6) {
            formatted += ` (${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6, 10)}`;
          }
          item.value = formatted;
        } else {
          let tel = digits;
          if (tel.length > 3 && tel.length <= 6) {
            tel = `(${tel.slice(0, 3)}) ${tel.slice(3)}`;
          } else if (tel.length > 6) {
            tel = `(${tel.slice(0, 3)}) ${tel.slice(3, 6)}-${tel.slice(6, 10)}`;
          }
          item.value = tel;
        }
      }
    },
    handleSave () {
      const territoryStore = useTerritoryStore();
      territoryStore.incomplete = [];
      territoryStore.submitTerritory();
    },
    handleCloseWarning () {
      useTerritoryStore().isWarning = false;
    },
    getOptions (value) {
      switch (value.field) {
        case 'territory':
          return this.Territories.map((item) => {
            return { id: item.territoryId, name: item.manager + ': ' + item.territory, value: item.territoryId };
          });
        case 'state':
          return this.States;
        case 'regions':
          return this.Regions.map((item) => {
            return { id: item.regionId, name: item.region, value: item.regionId};
          });
      }
    }
  }
};
</script>

<style scoped>
.tf-submit-btn {
  cursor: pointer;
  user-select: none;
  color: #FFFFFF;
  padding: 5px;
  width: 70px;
  text-align: center;
  background-color: var(--nelson-green);
}
.tf-cancel-btn {
  cursor: pointer;
  user-select: none;
  color: #FFFFFF;
  padding: 5px;
  width: 70px;
  text-align: center;
  background-color: red;
}
.tf-form-btn-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.modal-test-submit-invalid-prompt {
  padding-top: 10px;
  background-color: #ffffff;
  display: flex;
  align-items: start;
}
.modal-test-invalid-prompt {
  background-color: #ffffff;
  border: 3px solid var(--red);
  padding: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tf-warning-value-box {
  display: grid;
  grid-template-columns: auto auto auto;
  gap: 0px 10px;
  width: 100%;
}
.tf-warning-cont-box {
  display: flex;
  flex-direction: row;
}
.tf-warning-value-text {
  font-size: 14px;
  font-weight: 550;
}
.tf-data-inputs {
  height: 100%;
}
.tf-warning-cont-text {
  width: 100%;
}
.tf-warning-cont-img-box {
  width: 20%;
  display: flex;
  justify-content: flex-end;
  align-items: start;
}
.tf-warning-cont-img {
  width: 10px;
  margin: 5px;
  cursor: pointer;
}
</style>